import axios, { AxiosResponse } from 'axios';

import { SearchRequest } from 'core/util/Search';
import { AuditEntity, MissingFieldData } from 'directory/listings/notification-modals/types';

export const searchAudits = async (tenantId: number, search: SearchRequest): Promise<AuditEntity[]> => {
    const { data }: AxiosResponse<AuditEntity[]> = await axios.post(`/api/tenants/${tenantId}/bl-audits-entities`, {
        search,
    });

    return data || [];
};

export const getMissingProfileFieldData = async (
    agencyId: number,
    tenantId: number,
    searchRequest: SearchRequest,
): Promise<MissingFieldData[]> => {
    const { data }: AxiosResponse<MissingFieldData[]> = await axios.post(
        `/api/agencies/${agencyId}/tenants/${tenantId}/bl-audits/missing-field-data`,
        searchRequest,
    );

    return data || [];
};
